import { action, computed } from 'mobx';
import { GTMReporters } from 'components/HOCs/withGtmLogger';
import { SubscriptionPageProps } from './SubscriptionPageProps';
import { ServicePendingChangesInfo } from 'types';

export class SubscriptionPageController {
  constructor(private readonly props: SubscriptionPageProps) {
    void this.notifyGTM();
  }

  notifyGTM = async () => {
    const { storage } = this.props.rootStore.appStore;
    storage.getCycleSectionViewed().then(
      () => {},
      async () => {
        await storage.setCycleSectionViewed();
        this.props.reportGTM(GTMReporters.CycleSelector);
      },
    );
  };

  getFooterKey = () => {
    const { pricesIncludeTax } = this.props.rootStore.appStore;

    return pricesIncludeTax
      ? 'page_footer.subscription_disclaimer_no_vat'
      : 'page_footer.subscription_disclaimer_applicable_tax';
  };

  @action
  closeNoWebsiteModal = () => {
    this.props.rootStore.appStore.setNoWebsiteModal(false);
  };

  @action
  openNoWebsiteModal = () => {
    this.props.rootStore.appStore.setNoWebsiteModal(true);
  };

  @action
  onCycleSelect = () => {
    const { onCycleSelect } = this.props;
    const { removeUnloadListener, appContext } = this.props.rootStore.appStore;

    if (appContext.siteGuid) {
      onCycleSelect();
      return;
    }
    removeUnloadListener();
    this.openNoWebsiteModal();
  };

  @computed
  get serviceHasPendingChanges(): boolean {
    return !!this.props.rootStore.appStore.appContext.servicePendingChangesInfo
      ?.servicePendingChanges?.billingCycle?.billingCycle;
  }

  @computed
  get servicePendingChangesInfo(): ServicePendingChangesInfo | undefined {
    return this.props.rootStore.appStore.appContext.servicePendingChangesInfo;
  }
}
